import React from 'react';

export type PolymorphProps<CType extends React.ElementType = 'article'> = {
    /**
     * Polymorph the component to another html tag
     * @default article
     */
    as?: CType;
} & React.PropsWithChildren &
    React.ComponentPropsWithoutRef<CType>;

function Polymorph<CType extends React.ElementType = 'article'>({ children, as, ...rest }: PolymorphProps<CType>) {
    const Component = as ?? 'article';
    return <Component {...rest}>{children}</Component>;
}

export default Polymorph;
